export default __webpack_public_path__ + "static/blob10-ff5d4ebb271535475b2a4cc47e4389c4.svg";